import axios from "axios";
import React, { useState, useEffect } from "react";
import { BsFillPersonFill } from "react-icons/bs";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { API_HOST } from "../api_utils";
import { Box, Divider, Modal } from "@material-ui/core";
import Loader from "../Shared_Components/Loader";
import { TbArrowBackUp } from "react-icons/tb";
import { RiSave2Fill } from "react-icons/ri";

function Login(props) {
  let navigate = useNavigate();

  const [loginData, setLoginData] = useState({
    login_name: "",
    password: "",
  });

  const [editPassword, setEditPassword] = useState({
    login_name: "",
    password: "",
    confirm_pass: "",
  });

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);

  const { colorTheme } = props;

  let userDetail = JSON.parse(sessionStorage.getItem("user"));

  // allow user to login with email and password:
  const loginHandler = async () => {
    //
    if (loginData.login_name && loginData.password) {
      try {
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const { data } = await axios.post(
          `${API_HOST}/api/users/login`,
          loginData,
          config
        );

        if (data.message) {
          toast.error(data.message);
        } else {
          sessionStorage.setItem("user", JSON.stringify(data));
          navigate("/home");
          window.location.reload();
        }
      } catch (error) {
        toast.error(error.response.data.message);
      }
    } else {
      toast.error("Make Sure To Fill All Fields !!!");
    }
  };

  // redirect to register screen:
  const resetPasswordHandler = () => {
    setOpen(true);
  };

  const updatePasswordHandler = async () => {
    if (
      editPassword.login_name &&
      editPassword.password &&
      editPassword.confirm_pass
    ) {
      if (editPassword.password === editPassword.confirm_pass) {
        const { data } = await axios.post(
          `${API_HOST}/api/users/change_password_new`,
          editPassword
        );
        if (data.message === "User Password Updated Successfully !!!") {
          toast.success(data.message);
          setOpen(false);
          setEditPassword({
            login_name: "",
            password: "",
            confirm_pass: "",
          });
        } else {
          toast.error(data.message);
          setEditPassword({
            login_name: "",
            password: "",
            confirm_pass: "",
          });
        }
      } else {
        toast.warn("Passwords Do Not Match");
      }
    } else {
      toast.warn("Make Sure To Fill All Fields !!!");
    }
  };

  return (
    <div className="xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[6%] xl:mt-[4%] h-[94vh] mt-[12%] bg-sky-50 md:h-[87vh] lg:h-[90vh] xl:h-[87vh] 2xl:h-[92.5vh]">
      <div className="flex justify-center flex-col items-center lg:mt-[3rem] mt-[30%] md:mt-0 ">
        <div className="bg-white shadow-xl w-[100%] lg:w-[50%] rounded-lg ">
          <p
            style={{ backgroundColor: colorTheme }}
            className=" rounded-t-lg p-[0.8rem] text-white tracking-wide ">
            Login
          </p>
          <div>
            <div className="flex justify-start items-center p-[1rem]">
              <label htmlFor="loginName" className="md:w-[8rem] w-[6.5rem]">
                Login Name
              </label>
              <input
                className="border border-gray-300 flex-1 p-[0.2rem] outline-none  bg-blue-100"
                type="text"
                placeholder="Enter Your Login Name "
                id="loginName"
                onChange={(e) =>
                  setLoginData((prevState) => ({
                    ...prevState,
                    login_name: e.target.value,
                  }))
                }
                value={loginData.email}
              />
            </div>
            <div className="flex justify-start items-center p-[1rem]">
              <label htmlFor="loginPass" className="md:w-[8rem] w-[6.5rem]">
                Password
              </label>
              <input
                className="border border-gray-300 flex-1 p-[0.2rem] outline-none  bg-blue-100"
                type="password"
                placeholder="Enter Your Login Password "
                id="loginPass"
                onChange={(e) =>
                  setLoginData((prevState) => ({
                    ...prevState,
                    password: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="flex justify-end items-center p-[1rem]">
            <button
              style={{ backgroundColor: colorTheme }}
              onClick={loginHandler}
              className=" flex justify-start items-center px-[1rem] py-[0.3rem]  rounded-lg t">
              <p className="text-white tracking-wide mr-[0.5rem]">
                <BsFillPersonFill />
              </p>
              <p className=" text-white tracking-wide">Login</p>
            </button>
          </div>
        </div>
        {/* <p
          onClick={resetPasswordHandler}
          className="text-sky-400 hover:text-sky-600 font-Roboto text-[1.1rem] mt-3 cursor-pointer transition duration-[0.3s]">
          Set Password for first time ?
        </p> */}
      </div>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="lg:w-[50%] md:w-[50%] w-[80%] rounded-lg bg-white absolute top-[10%]  mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Update User Password</p>
              </div>
              <Divider />
              <div className="p-[0.5rem]">
                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="oldPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Login Name</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPassword((prevState) => ({
                        ...prevState,
                        login_name: e.target.value,
                      }))
                    }
                    value={editPassword?.login_name}
                    type="text"
                    id="oldPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User Login Name"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="newPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">New Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPassword((prevState) => ({
                        ...prevState,
                        password: e.target.value,
                      }))
                    }
                    value={editPassword?.password}
                    type="text"
                    id="newPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Enter User New Password"
                  />
                </div>

                <div className="grid grid-cols-4 mt-2">
                  <label
                    htmlFor="confirmNewPass"
                    className="flex justify-start items-center col-span-1 space-x-1">
                    <span className="text-gray-700">Confirm Password</span>
                  </label>
                  <input
                    onChange={(e) =>
                      setEditPassword((prevState) => ({
                        ...prevState,
                        confirm_pass: e.target.value,
                      }))
                    }
                    value={editPassword?.confirm_pass}
                    type="text"
                    id="confirmNewPass"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-3"
                    placeholder="Confirm New Password"
                  />
                </div>

                <div className="flex justify-end items-center space-x-4 mt-8 mb-4">
                  <button
                    onClick={() => setOpen(false)}
                    className="flex justify-center items-center space-x-2 bg-purple-400 text-purple-50 px-[1rem] py-[0.5rem] rounded hover:text-purple-500 hover:bg-purple-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={updatePasswordHandler}
                    className="flex justify-center items-center space-x-2 bg-green-400 text-green-50 px-[1rem] py-[0.5rem] rounded hover:text-green-500 hover:bg-green-50 transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Login;
